import { render } from "./FoldersNew.vue?vue&type=template&id=fc1d9998"
import script from "./FoldersNew.vue?vue&type=script&lang=js"
export * from "./FoldersNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__